import { render, staticRenderFns } from "./scores-settings.vue?vue&type=template&id=77a8a389&scoped=true"
import script from "./scores-settings.vue?vue&type=script&lang=js"
export * from "./scores-settings.vue?vue&type=script&lang=js"
import style0 from "./scores-settings.vue?vue&type=style&index=0&id=77a8a389&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a8a389",
  null
  
)

export default component.exports